export const CRISIS_REPORT_TABLE_HEADERS_MARKED = [
  'timeCrisisCallReceived',
  'timeStaffCompletedContact',
  'responseDuration',
];

const CRISIS_REPORT_TABLE_HEADERS = [
  {
    label: 'Client EMR MRN',
    key: 'clientId',
  },
  {
    label: 'Client First Name',
    key: 'clientFirstName',
  },
  {
    label: 'Client Last Name',
    key: 'clientLastName',
  },
  {
    label: 'Date Crisis Call Received',
    key: 'dateCrisisCallReceived',
  },
  {
    label: 'Time Crisis Call Received',
    key: 'timeCrisisCallReceived',
  },
  {
    label: 'Assigned Team Member(s)',
    key: 'assignedTeamMembers',
  },
  {
    label: 'Time Crisis Client Assigned to Staff',
    key: 'allocationTime',
  },
  {
    label: 'Time Staff Made Contact',
    key: 'timeStaffMadeContact',
  },
  {
    label: 'Time Staff Completed Contact',
    key: 'timeStaffCompletedContact',
  },
  {
    label: 'Crisis Response Duration',
    key: 'crisisResponseDuration',
  },
  {
    label: 'Visit Documented By',
    key: 'visitDocumentedBy',
  },
  {
    label: 'Location of Crisis Event',
    key: 'locationOfCrisisEvent',
  },
  {
    label: 'Disposition',
    key: 'disposition',
  },
  {
    label: 'Dispatcher Resolved',
    key: 'dispatcherResolved',
  },
  {
    label: 'Police Presence',
    key: 'policePresence',
  },
  {
    label: 'No Show',
    key: 'noShow',
  },
  {
    label: 'Manual',
    key: 'isFollowUp',
  },
];

export const CrisisVisitType = {
  Any: 'Any',
  FollowUp: 'FollowUp',
  NonFollowUp: 'NonFollowUp',
  NonApplicable: 'NonApplicable',
} as const;

export const VISIT_TYPE_OPTIONS = [
  { label: 'All', value: CrisisVisitType.Any },
  { label: 'Yes', value: CrisisVisitType.FollowUp },
  { label: 'No', value: CrisisVisitType.NonFollowUp },
  { label: 'N/A', value: CrisisVisitType.NonApplicable },
];

export const UNASSIGNED_TEAM_MEMBER = {
  firstName: 'Unassigned',
  lastName: '',
  id: 0,
};

export default CRISIS_REPORT_TABLE_HEADERS;
